// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N_WWF6RxWgMyBEfE4ed_ {
    border-top: 1px solid var(--mantine-color-gray-2);
    background: var(--mantine-color-white);
    padding: 16px 24px;
}

.EJZzyFFTkZAj0qtwJ2l6 {
    margin: 0 auto;
    max-width: 900px;
}

.cwDnrgW4PAhU1NAmI2I1 {
    color: var(--mantine-color-gray-3);
}

.SqV2nnjefSSHt5x0vJCw {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
    font-family: var(--mantine-font-family-monospace);
    font-size: 11px;
    color: var(--mantine-color-gray-6);
}

.SqV2nnjefSSHt5x0vJCw:hover {
    color: var(--mantine-color-gray-7);
}

.sEVBxMNjIP0w5mIbe7L_ {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--mantine-color-green-6);
}

.nS9uCCxfOziv1LR2UqH8 {
    margin: 12px auto 0;
    max-width: 900px;
    border-top: 1px dashed var(--mantine-color-gray-2);
    padding-top: 12px;
    font-family: var(--mantine-font-family-monospace);
    font-size: 11px;
    color: var(--mantine-color-gray-5);
}

@media (max-width: 48em) {
    .N_WWF6RxWgMyBEfE4ed_ {
        padding: 16px 20px 24px;
    }
}

/* Click-to-copy the full server identity. Kept visually inert (no visible
   button chrome) so the drawer still reads as plain monospace text, matching
   Footer.module.css's .copyRow. */
.qZfpgPHnqL5G23L0iuo3 {
    font-family: var(--mantine-font-family-monospace);
    font-size: 11px;
    color: var(--mantine-color-gray-5);
    cursor: pointer;
}

.qZfpgPHnqL5G23L0iuo3:disabled {
    cursor: default;
}

.qZfpgPHnqL5G23L0iuo3:hover:not(:disabled) {
    color: var(--mantine-color-brand-6);
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./Components/Footer/LoginBuildChip.module.css"],"names":[],"mappings":"AAAA;IACI,iDAAiD;IACjD,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iDAAiD;IACjD,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kDAAkD;IAClD,iBAAiB;IACjB,iDAAiD;IACjD,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;;kCAEkC;AAClC;IACI,iDAAiD;IACjD,eAAe;IACf,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;AAC9B","sourcesContent":[".root {\n    border-top: 1px solid var(--mantine-color-gray-2);\n    background: var(--mantine-color-white);\n    padding: 16px 24px;\n}\n\n.row {\n    margin: 0 auto;\n    max-width: 900px;\n}\n\n.sep {\n    color: var(--mantine-color-gray-3);\n}\n\n.chip {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 0;\n    font-family: var(--mantine-font-family-monospace);\n    font-size: 11px;\n    color: var(--mantine-color-gray-6);\n}\n\n.chip:hover {\n    color: var(--mantine-color-gray-7);\n}\n\n.dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: var(--mantine-color-green-6);\n}\n\n.drawer {\n    margin: 12px auto 0;\n    max-width: 900px;\n    border-top: 1px dashed var(--mantine-color-gray-2);\n    padding-top: 12px;\n    font-family: var(--mantine-font-family-monospace);\n    font-size: 11px;\n    color: var(--mantine-color-gray-5);\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n    .root {\n        padding: 16px 20px 24px;\n    }\n}\n\n/* Click-to-copy the full server identity. Kept visually inert (no visible\n   button chrome) so the drawer still reads as plain monospace text, matching\n   Footer.module.css's .copyRow. */\n.copyRow {\n    font-family: var(--mantine-font-family-monospace);\n    font-size: 11px;\n    color: var(--mantine-color-gray-5);\n    cursor: pointer;\n}\n\n.copyRow:disabled {\n    cursor: default;\n}\n\n.copyRow:hover:not(:disabled) {\n    color: var(--mantine-color-brand-6);\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `N_WWF6RxWgMyBEfE4ed_`,
	"row": `EJZzyFFTkZAj0qtwJ2l6`,
	"sep": `cwDnrgW4PAhU1NAmI2I1`,
	"chip": `SqV2nnjefSSHt5x0vJCw`,
	"dot": `sEVBxMNjIP0w5mIbe7L_`,
	"drawer": `nS9uCCxfOziv1LR2UqH8`,
	"copyRow": `qZfpgPHnqL5G23L0iuo3`
};
export default ___CSS_LOADER_EXPORT___;
